module.exports = __webpack_public_path__ + "img/checkin_2.42b7002e.png";